var EHDI = EHDI || Object.create(null);

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.TitleScene = function() {
    EHDI.aka.Container.call(this);
}

EHDI.scene.TitleScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.TitleScene.prototype.initProps = function() {
    
}

EHDI.scene.TitleScene.prototype.initGraphics = function() {
    

    this.title = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_titlelogo"]);
    this.title.scaleX = this.title.scaleY = 0;
    this.title.anchor.set(0.5, 0.5);
    this.title.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.45);
    this.addChild(this.title);

    this.gizmo = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_titlegizmo"]);
    this.gizmo.anchor.set(0.5, 0.5);
    this.gizmo.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.49, EHDI.GAME.sceneManager.getStageHeight() * 1.5);
    this.addChild(this.gizmo);

    this.sound = new EHDI.displays.ToggleButton(EHDI.Assets.images["btn_audio1"], EHDI.Assets.images["btn_audio3"], EHDI.Assets.images["btn_audio2"], EHDI.Assets.images["btn_audio4"], EHDI.GAME.soundManager.getMuted());
    this.sound.setOnClickFunction(this.toggleAudio);
    this.sound.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.1, EHDI.GAME.sceneManager.getStageHeight() * 0.09);
    this.addChild(this.sound);

     this.closeBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_close"], null, null, null,0.8);
  this.closeBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.95, EHDI.GAME.sceneManager.getStageHeight() * 0.09);
  this.closeBtn.setOnClickFunction(function(){
    location.href = "?isGameStarted=false"
  });
  this.addChild(this.closeBtn);
    
    // this.highScoreHolder = new EHDI.components.HighScoreHolder(this, EHDI.GAME.saveData.highScore);
    // this.highScoreHolder.setXY(EHDI.GAME.sceneManager.getStageWidth() * 0.723, EHDI.GAME.sceneManager.getStageHeight() * 0.0417);

    this.playBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_play"], EHDI.Assets.images["btn_play2"], null, null);
    this.playBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.85);
    this.addChild(this.playBtn);
    
    this.playBtn.setOnClickFunction(this.startGame);
    
    this.playTxt = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("BTN_PLAY"));
    this.playTxt.anchor.set(0.75, 0.5);
    this.playBtn.addChild(this.playTxt);

    this.tl = new TimelineMax({repeat: 0}); 
    this.tl.to(this.title, 0.5, {scaleX:1, scaleY:1, ease: Back.easeOut});
    this.tl.to(this.gizmo, 0.75, {x:EHDI.GAME.sceneManager.getStageWidth() * 0.59, y:EHDI.GAME.sceneManager.getStageHeight() * 0.79, ease: Back.easeOut});
    this.tl.add(this.gizmoFloat.bind(this));
    this.tl.play();

}

EHDI.scene.TitleScene.prototype.initListeners = function() {
    
}

EHDI.scene.TitleScene.prototype.killProps = function() {
    
}

EHDI.scene.TitleScene.prototype.killGraphics = function() {
    console.log("destroying");
    if(this.tl != null)
    {
        this.tl.kill();
    }
    delete this.tl;

    if(this.playTxt != null)
    {
        this.playBtn.removeChild(this.playTxt);
        this.playTxt.destroy({children: true});
    }
    delete this.playTxt;

    if(this.playBtn != null)
    {
        this.removeChild(this.playBtn);
        this.playBtn.destroy({children: true});
    }
    delete this.playBtn;
    if(this.closeBtn != null)
    {
    this.removeChild(this.closeBtn);
    this.closeBtn.destroy({children: true});
    }
    delete this.closeBtn;

    if(this.sound != null)
    {
        this.removeChild(this.sound);
        this.sound.destroy({children: true});
    }
    delete this.sound;

    if(this.gizmo != null)
    {
        this.removeChild(this.gizmo);
        this.gizmo.destroy({children: true});
    }
    delete this.gizmo;

    if(this.title != null)
    {
        this.removeChild(this.title);
        this.title.destroy({children: true});
    }
    delete this.title;

    if(this.bg != null)
    {
        this.removeChild(this.bg);
        this.bg.destroy({children: true});
    }
    delete this.bg;
}

EHDI.scene.TitleScene.prototype.killListeners = function() {
    
}

EHDI.scene.TitleScene.prototype.screenWillAppear = function() {
    this.bg = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_titlebg"]);
    
    this.addChild(this.bg);
};

EHDI.scene.TitleScene.prototype.screenDidAppear = function() {

    this.initProps();
    this.initGraphics();
    this.initListeners();

    /*
    if(!EHDI.GAME.debugUtils) {
        EHDI.GAME.debugUtils = new EHDI.debugUtils.debugUtilsContainer("v0.3.5");
        // EHDI.GAME.sceneManager.addNotification(EHDI.GAME.debugUtils);
    }*/

    if(!EHDI.GAME.bgm)
    {
        EHDI.GAME.soundManager.autoResumeToggle(true);
        EHDI.GAME.bgm = EHDI.GAME.soundManager.playBGM("bgm", 0.75);
    }
    
};

EHDI.scene.TitleScene.prototype.toggleAudio = function(enable) {
    EHDI.GAME.soundManager.setMute(enable);
    
    EHDI.GAME.soundManager.playSFX("button_sfx");
    var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
     if(cache)
    {
    cache.isMuted = enable;
     EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
    }
    else
    EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, {isMuted : enable});
}


EHDI.scene.TitleScene.prototype.startGame = function() {
    
    EHDI.GAME.soundManager.playSFX("button_sfx");
    EHDI.GAME.gameObject = new EHDI.scene.GameScene()
    EHDI.GAME.sceneManager.changeScene(EHDI.GAME.gameObject, {x : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageWidth(), 0), duration : 0.25});
};

EHDI.scene.TitleScene.prototype.screenDidDisappear = function() {
    this.killListeners();
    this.killGraphics();
    this.killProps();
    this.destroy({children: true});
    delete this;
}

EHDI.scene.TitleScene.prototype.gizmoFloat = function() {
    this.tl.kill();
    this.tl = new TimelineMax({repeat: -1, yoyo: true});
    this.tl.to(this.gizmo, 0.5, {y: this.gizmo.y - 10, ease: Power0.easeNone});
    this.tl.play();
}

